import { useState } from 'react'
import { STARTER_CATEGORIES } from '@/config'
import { Button } from '@/components/Button'
import { createStarterCategories } from '@/data/household'
import { useAuth } from '@/store/auth'
import { setOnboarding, useHousehold } from '@/store/household'
import './Onboarding.css'

/** First run, step 3: starter categories with one tap. Created only if tapped. */
export function StarterCategoriesScreen() {
  const user = useAuth((s) => s.user)!
  const hid = useHousehold((s) => s.hid)!
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const onAdd = async () => {
    setBusy(true)
    try {
      await createStarterCategories(hid, user.uid)
      setOnboarding('none')
    } catch (err) {
      setError((err as Error).message)
      setBusy(false)
    }
  }

  return (
    <main className="onboard">
      <header className="onboard__header">
        <h1 className="onboard__title">Start with these categories?</h1>
        <p className="onboard__lead">Every task can carry one. Rename, recolour or archive them any time in Settings.</p>
      </header>
      <ul className="onboard__chips" aria-label="Starter categories">
        {STARTER_CATEGORIES.map((c) => (
          <li key={c.name} className="chip chip--static">
            <span className="chip__dot" style={{ background: `var(--${c.color})` }} />
            {c.name}
          </li>
        ))}
      </ul>
      {error && (
        <p className="onboard__error" role="alert">
          {error}
        </p>
      )}
      <div className="onboard__actions">
        <Button variant="primary" size="lg" block onClick={onAdd} disabled={busy}>
          Add these
        </Button>
        <Button variant="quiet" size="lg" block onClick={() => setOnboarding('none')} disabled={busy}>
          Skip for now
        </Button>
      </div>
    </main>
  )
}
